import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { UiModule } from '@eg/ui';
import { QuickFiltersService } from './service/quick-filters.service';
import { QuickFiltersBarComponent } from './quick-filters-bar/quick-filters-bar.component';
import { QuickFiltersSearchComponent } from './quick-filters-search/quick-filters-search.component';
import { QuickFiltersHeaderComponent } from './quick-filters-header/quick-filters-header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { QuickFiltersTableComponent } from './quick-filters-table/quick-filters-table.component';
import { TableNotFoundModule } from '../table-not-found';

@NgModule({
  declarations: [QuickFiltersHeaderComponent, QuickFiltersSearchComponent, QuickFiltersBarComponent, QuickFiltersTableComponent],
  imports: [CommonModule, TranslocoModule, FlexLayoutModule, UiModule, ReactiveFormsModule, TableNotFoundModule],
  providers: [QuickFiltersService],
  exports: [QuickFiltersHeaderComponent, QuickFiltersSearchComponent, QuickFiltersBarComponent, QuickFiltersTableComponent],
})
export class QuickFiltersModule {}
